import React, { Fragment } from "react"
import { Container, Typography } from "@material-ui/core"
import Chips from "components/Chips"
import { AppStyles } from "assets/styles/App"
import HeroBottom from "shapes/HeroBottom"

interface Props {}

const Hero: React.FC<Props> = () => {
  const classes = AppStyles()

  // const data = useStaticQuery(graphql`
  //   query {
  //     file(relativePath: { eq: "arif-hero.jpg" }) {
  //       childImageSharp {
  //         fluid {
  //           ...GatsbyImageSharpFluid
  //         }
  //       }
  //     }
  //   }
  // `)
  // <Img
  //   className={classes.avatar}
  //   fluid={data.file.childImageSharp.fluid}
  //   alt="Arif"
  // />

  return (
    <Fragment>
      <Chips />
      <Container maxWidth={false} className={classes.heroOuter}>
        <Container
          maxWidth="md"
          className={`${classes.heroInner} slide-in-fwd-center`}
        >
          <Typography
            className={classes.heroTitle}
            variant="h2"
            align="center"
            color="textPrimary"
            gutterBottom
          >
            Hi, Arif here
            <span role="img">😊</span>
          </Typography>
          <Typography
            className={classes.heroDesc}
            variant="h5"
            align="center"
            color="textPrimary"
            paragraph
          >
            Hi, I am Arif. I am a <strong>Web App Developer</strong>. Currently
            focusing on <strong>Javascript</strong> language and learning new
            technologies to maximise my capabilities. My main skills are{" "}
            <strong>React</strong> and <strong>React Native</strong>. However, I
            also enjoy doing back-end stuff using <strong>NodeJs</strong> and{" "}
            <strong>Ruby on Rails</strong>. As for hobbies, I love to play
            around with <strong>Machine Learning</strong> using
            <strong>TensorflowJs</strong> and <strong>NoSql</strong> database
            using <strong>MongoDB</strong> or <strong>FireBase RTDB</strong>.
            <span role="img">⚡️⚡️</span>
          </Typography>
        </Container>
        <HeroBottom />
      </Container>
    </Fragment>
  )
}

export default Hero
